$(document).ready(function () {
  $(document).on("click", ".ajax-add-to-cart", function () {
    var ajaxVariantID = $(this).attr("data-variantId");
    if ($(this).is("[data-selling-planID]")) {
      var sellingID = $(this).attr('data-selling-planID');
    }else{
      var sellingID = '';
    }

    addToCartJS(1, ajaxVariantID, sellingID, $(this));
    $(".loading-button").addClass("active");
    $(".icon-addto-cart").addClass("active");
  });
  function addToCartJS(qty, variantID, sellingID,  btn) {
    // Open the cart drawer
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionsToRender = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    var sections_url = window.location.pathname;
    // Send request to add item to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        quantity: qty,
        id: variantID,
        sections: sectionsToRender,
        sections_url: sections_url,
        selling_plan: sellingID,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        cartDrawer.renderContents(response);
        cartDrawer.open();
        if (cartDrawer && cartDrawer.classList.contains("is-empty"))
          cartDrawer.classList.remove("is-empty");
        $(".loading-button").removeClass("active");
        $(".icon-addto-cart").removeClass("active");
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
      });
  }
  
  $(".testimonial-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    adaptiveHeight: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".net-cvr").first().addClass("active").next("div").show();
  $(".net-cvr").click(function () {
    $(this).next("div").toggle("fast");
    $(this).toggleClass("active");
    $(".net-cvr").not(this).removeClass("active").next("div").hide("fast");
  });

  $(".accordion-content-section .net-cvr").first().removeClass("active").next("div").hide();

  $(".continue-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // Adjust the speed for how fast/slow the slider should move
    cssEase: "linear", // Ensures smooth, continuous scrolling
    infinite: true, // Loop infinitely
    pauseOnHover: false,
    speed: 8000,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".image-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // product page list item button
  // Initially, make the first tab (benefits) active
  $('.tab-button[data-tab="benefits"]').addClass("active");
  $("#benefits-tab").show();
  $("#description-tab").hide();

  // When a tab button is clicked
  $(".tab-button").on("click", function () {
    var tab = $(this).data("tab");

    // Remove 'active' class from all buttons
    $(".tab-button").removeClass("active");

    // Add 'active' class to the clicked button
    $(this).addClass("active");

    // Hide all content sections
    $(".tab-content").hide();

    // Show the selected content section
    $("#" + tab + "-tab").show();
  });

  $(".content-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(document).on("change", ".field_describes input", function () {
    var getNumAttr = $(this)
      .closest(".field_describes")
      .find("label")
      .data("attr-num");
    if (getNumAttr == 1) {
      $(".sole-trader--input").css("display", "block");
      $(".limited-company--input").css("display", "none");
    } else if (getNumAttr == 2) {
      $(".limited-company--input").css("display", "block");
      $(".sole-trader--input").css("display", "none");
    }
  });

  //PDP Thumbnail slider
  // Function to adjust thumbnail height
  function adjustThumbnailHeight() {
    var mainImageHeight = $(
      ".product--thumbnail_slider .product__media-list"
    ).outerHeight(); // Get the height of the main image
    $(".product--thumbnail_slider .thumbnail-slider").height(mainImageHeight); // Apply the height to the thumbnail slider
  }

  // Adjust height on page load
  adjustThumbnailHeight();

  // Adjust height on window resize
  $(window).resize(function () {
    adjustThumbnailHeight();
  });

  //PDP Thumbnail Dots slider
  $(".thumbnails_dot").first().addClass("active");
  $(document).on("click", ".thumbnails_dot", function () {
    $(".thumbnails_dot").removeClass("active");
    $(this).addClass("active");
    var dotIndex = $(this).data("index");
    $(".thumbnail-list__item").each(function (index) {
      if (dotIndex == index) {
        console.log("Clicked thumbnail index: " + index);
        $(".thumbnail-list__item").eq(index).find("button").trigger("click");
      }
    });
  });

  $(document).on("click", ".thumbnail-list__item", function () {
    var thumbnailIndex = $(this).index();
    console.log("Thumbnail clicked index: " + thumbnailIndex);

    $(".thumbnails_dot").removeClass("active");
    $(".thumbnails_dot").eq(thumbnailIndex).addClass("active");
  });

  // Subscription Section JS
  $(document).on(
    "change",
    ".popular-product-section-subscribr-btn input",
    function () {
      if ($(this).is(":checked")) {
        $(".product-subscription-two").addClass("active");
        // $(".subscription-product-section-cover").removeClass("active");
        $(".product-subscription-one").removeClass("active");
      } else {
        // $(".subscription-product-section-cover").addClass("active");
        $(".product-subscription-one").addClass("active");
        $(".product-subscription-two").removeClass("active");
      }
    }
  );

  if ($(".loop-custom-widget-wrapper").length > 0) {
    function handleRadioChange() {
      if ($(".subscription-purchase-option").is(":checked")) {
        var selectedSubSucriptionVal = $(".subscription-frequency-container .subscription-frequency-item-list button.active").val();
        console.log("selectedSubSucriptionVal ",selectedSubSucriptionVal);
        if ($("input[name='selling_plan']").length === 0) {
          var inputAdd = `<input name="selling_plan" class="selling-plan-input" type="hidden" value="${selectedSubSucriptionVal}">`;
          $(".product-variant-id").after(inputAdd);
        }
      } else {
        $("input[name='selling_plan']").remove();
      }
      if ($(".ontitme-purchase-option").is(":checked")) {
        $(".subscription-frequency-container").hide();
        $(".subscription-frequency-container-2").show();

        //Set selected variantID to input
        var dataSelectedProductVariantId = $(".subscription-frequency-container-2 .subscription-frequency-item-list button.active").val();
        $(".product-variant-id").val(dataSelectedProductVariantId);
        
      } else if ($(".subscription-purchase-option").is(":checked")) {
        $(".subscription-frequency-container").show();
        $(".subscription-frequency-container-2").hide();

        //set the variant id on subscripiton selection
        var dataSelectedSellingPlanVariantId = $(".subscription-frequency-container .subscription-frequency-item-list button.active").attr("data-selling-plan-variant-id");
        $(".product-variant-id").val(dataSelectedSellingPlanVariantId);
      }
    }

    $(".loop-custom-widget-inner input[type='radio']").change(function () {
      handleRadioChange();
    });
    handleRadioChange();

    //Set first variant button as active
    $(".subscription-frequency-container-2 button").first().addClass("active");

    $(document).on("click",".subscription-frequency-container-2 [data-varaint-index]",function () {
        $(".subscription-frequency-container-2 button").removeClass("active");
        $(this).addClass("active");
        var getShowPrice = $(".subscription-frequency-container-2 button.active").next().find("span").html();
        $('[for="one-time-option"] .loop-widget-show-price').text(getShowPrice);
   
        var oneTimePurchaseValue = $(this).attr("value");
        oneTimePurchase(oneTimePurchaseValue);
        //Trigger subscription freq button
        var dataVariantIndex = $(this).attr("data-varaint-index");
      }
    );
    
    $(document).on("click",".subscription-frequency-container button",function () {
        $(".subscription-frequency-container button").removeClass("active");
        $(this).addClass("active");
        sellingPlanFrequency();
        var getShowPrice = $(".subscription-frequency-container button.active").next().find(".subscription-price-show").html();
      
        $('[for="subscription-option"] .loop-widget-price-show').text(getShowPrice);

        // var getShowPriceone = $(".subscription-frequency-container-2 button.active").next().find("span").html();
        // $('[for="one-time-option"] .loop-widget-show-price').text(getShowPriceone);

      
        //Trigger variant buttons
        var dataSellingPlanVariantId = $(this).attr("data-selling-plan-variant-id");
        // $(this).closest(".loop-custom-widget-inner").find("[data-variant-value='" + dataSellingPlanVariantId + "']").click();
        $(".product-variant-id").val(dataSellingPlanVariantId);
        setTimeout(function () {}, 100);
      }
    );

    
    function sellingPlanFrequency() {
      if ($(".subscription-purchase-option").is(":checked")) {
        var sellingPlanId = $(
          ".subscription-frequency-container button.active"
        ).val();
        $(".selling-plan-input").attr("value", sellingPlanId);
      }
    }

    function oneTimePurchase(value) {
      if ($(".ontitme-purchase-option").is(":checked")) {
        $(".product-variant-id").attr("value", value);
      }
    }
  }

  

  //Trigger first subscription
  $(".subscription-frequency-container .subscription-frequency-item-list.active").find("button").trigger("click");
  
  // product page after 5 date show  
  var currentDate = new Date();
  var givenDate = $(".icon-with-content .set-date").attr("data-date");
  // Add days to the given date
  currentDate.setDate(currentDate.getDate() + parseInt(givenDate));

  // Format the result to "day month" format
  var options = { day: "numeric", month: "long" };
  var resultDate = currentDate.toLocaleDateString("en-GB", options); // Using 'en-GB' for day-month order

  $(".icon-with-content .set-date").text(resultDate);

  // cart drawer subscription JS
  $(document).on(
    "click",
    ".cart-drawer-subscription-supply button",
    function () {
      // Remove active class from all buttons and add to the clicked one
      $(".cart-drawer-subscription-supply button").removeClass("active");
      $(this).addClass("active");
    }
  );

  // B2B Page Formula
  // Function to update the values based on the selected box
  function updatePotentialProfit(boxCount) {
    let packs = 50;
    let sachets = 100;
    let cost = 300;
    let profit = 200; // Default potential profit for 1 box

    // Adjust values based on the selected box
    if (boxCount === "5") {
      packs = 250;
      sachets = 500;
      cost = 1375;
      profit = 1125; // Correct potential profit for 5 boxes
    } else if (boxCount === "10") {
      packs = 500;
      sachets = 1000;
      cost = 2500;
      profit = 2500; // Correct potential profit for 10 boxes
    }

    // Update the input fields using jQuery
    $("#potentialProfit1").val(packs);
    $("#potentialProfit2").val(sachets);
    $("#potentialProfit3").val("£" + cost);

    // Update the potential profit total
    $(".potential-profit-section-total h4 span").text("= £" + profit);
  }

  // Event listener for dropdown selection change
  $("#potential_profit_section_select").on("change", function () {
    const selectedBox = $(this).val(); // Get selected box value using jQuery
    console.log(selectedBox);
    updatePotentialProfit(selectedBox); // Call function to update values
  });

  // Initialize with default selection (1 box)
  updatePotentialProfit("1");



  //Update cart item to subscription
  function removeProduct(variantId, qty, subscriptionPlanID, subscriptionVariantID) {
    // Open the cart drawer
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionsToRender = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    var sections_url = window.location.pathname;
    $.ajax({
      url: "/cart/change.js",
      method: "POST",
      data: {
        quantity: 0,
        id: variantId,
        sections: sectionsToRender, 
        sections_url: sections_url,
      },
      dataType: "json",
      success: function (response) {
        addToCartJSDrawer(qty, subscriptionVariantID, subscriptionPlanID);
        cartDrawer.renderContents(response);
        // cartDrawer.querySelector('.cart-drawer').classList.add('ajax-loader');
        // setTimeout(function () {
        //   cartDrawer.querySelector('.cart-drawer').classList.remove('ajax-loader');
        // },200);
      },
      error: function (error) {
        console.error("Error removing product:", error.responseText);
      },
    });
    
  }
  
  function updateCartItem(variantID, qty, subscriptionPlanID) {
    // Open the cart drawer
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionsToRender = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    var sections_url = window.location.pathname;
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { id: variantID, quantity: qty, selling_plan: subscriptionPlanID, sections: sectionsToRender, sections_url: sections_url, },
      dataType: "json",
      success: function (response) {
        cartDrawer.renderContents(response);
      },
      error: function (xhr, status, error) {
        console.error("Error updating Trolly:", error);
      }
    });
  }

  function addToCartJSDrawer(qty, variantID, sellingID) {
    // Open the cart drawer
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionsToRender = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    var sections_url = window.location.pathname;
    // Send request to add item to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        quantity: qty,
        id: variantID,
        sections: sectionsToRender,
        sections_url: sections_url,
        selling_plan: sellingID,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
      });
  }
  
  $(document).on("click",".cart-drawer-subscription-supply button", function () {
    var subscriptionVariantID = $(this).attr("data-subscription-variantID");
    var subscriptionPlanID = $(this).attr("value");
    // Get the cart items
    $.getJSON('/cart.js', function(cart) {
      // Loop through cart items
      cart.items.forEach(function(item) {
        var cartProductID = item.product_id;
        var cartVariantID = item.variant_id;
        if(cartProductID == 9702372770058){
          var qty = item.quantity; 
          if(subscriptionVariantID == cartVariantID){
             updateCartItem(cartVariantID, qty, subscriptionPlanID);
          }
          else{
            var qty = item.quantity; 
            removeProduct(cartVariantID, qty, subscriptionPlanID, subscriptionVariantID);
            // addToCartJSDrawer(qty, subscriptionVariantID, subscriptionPlanID);
          }
        }
      });
    });
  });
  
  
  if ($(".video-section").length > 0) {
    $(".video-section .video-section__poster").trigger("click");

    const videoElement = $(".video-section video")[0]; // Get the first video element

    // Check if the video exists and is not playing already
    if (videoElement && videoElement.paused) {
        videoElement.muted = true; // Ensure it's muted
        videoElement.play(); // Use play() method instead of triggering a click
    }
  }

});
